module.exports = __webpack_public_path__ + "static/media/2.23d95255.svg";